const QuantitySelector = {
  initialize: function () {
    this.setup();
  },

  setup: () => {

    this.selectorsIncrease = document.querySelectorAll('.quantity-selector__increase');
    if (this.selectorsIncrease.length == 0) {
      return;
    }

    QuantitySelector.handleIncrease();

    this.selectorsDecrease = document.querySelectorAll('.quantity-selector__decrease');
    if (this.selectorsDecrease.length == 0) {
      return;
    }

    QuantitySelector.handleDecrease();

  },

  handleIncrease: (selectorsIncrease) => {

    this.selectorsIncrease.forEach((increase) => {
      increase.addEventListener('click', function (e) {

        //Avoid incompatibility with ajax checkout
        if (e.target.classList.contains('qty-more')) {
          return;
        }

        e.preventDefault();

        let input = e.target.parentElement.parentElement.getElementsByClassName('quantity-selector__value');
        if (input.length == 0) {
          return;
        }

        let value = parseInt(input[0].value);
        value++;

        input[0].value = value;

      });
    });
  },

  handleDecrease: () => {
    this.selectorsDecrease.forEach((decrease) => {
      decrease.addEventListener('click', function (e) {

        //Avoid incompatibility with ajax checkout
        if (e.target.classList.contains('qty-less')) {
          return;
        }

        e.preventDefault();

        let input = e.target.parentElement.parentElement.getElementsByClassName('quantity-selector__value');
        if (input.length == 0) {
          return;
        }

        let value = parseInt(input[0].value);
        if (value > 1) {
          value--;
        }

        input[0].value = value;

      });
    });
  }
};

export default QuantitySelector;